import React from 'react'
import { string } from 'prop-types'
import { CCMessages, HelperCCMessages } from './ccMessages.jsx'

class ContactCenterOpening extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      ccData: HelperCCMessages.initialData
    }
  }

  componentDidMount () {
    HelperCCMessages.getData(data => {
      this.setState(data)
    })
  }

  getTypeData () {
    const { type } = this.props
    const { ccData } = this.state
    switch (type.toLowerCase()) {
      case 'airport':
        return {
          data: ccData['Airport'],
          key: 'ADMAIRPORTS',
          times: 'ADMcc'
        }
      case 'insurance':
        return {
          data: ccData['Insurance'],
          key: 'ADMINSURANCE',
          times: 'ADMccIns'
        }
      case 'newproducts':
        return {
          data: ccData['NewProducts'],
          key: 'ADMNEWPRODUCTS',
          times: ''
        }
      default:
        return {}
    }
  }

  render () {
    if (!this.props.type) return null
    const { id } = this.props
    const type = this.getTypeData()
    return (
      <span id={id}>
        <CCMessages ccData={type.data} HXCMKey={type.key} ccTimes={type.times} />
      </span>
    )
  }
}

ContactCenterOpening.propTypes = {
  type: string,
  id: string
}

export default ContactCenterOpening



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/contactCentre/contactCentreOpening.jsx